import { FiCheckCircle, FiInfo, FiX } from "react-icons/fi";

export interface ToastMessage {
  id: string;
  message: string;
  tone?: "success" | "error" | "info";
}

interface ToastRegionProps {
  toasts: ToastMessage[];
  onDismiss: (id: string) => void;
}

export function ToastRegion({ toasts, onDismiss }: ToastRegionProps) {
  return (
    <div className="clip-toasts" aria-live="polite" aria-atomic="true">
      {toasts.map((toast) => (
        <div className={`clip-toast ${toast.tone ?? "info"}`} key={toast.id} role={toast.tone === "error" ? "alert" : "status"}>
          {toast.tone === "success" ? <FiCheckCircle /> : <FiInfo />}
          <span>{toast.message}</span>
          <button type="button" onClick={() => onDismiss(toast.id)} aria-label="Dismiss notification"><FiX /></button>
        </div>
      ))}
    </div>
  );
}
